import { useMemo } from 'react';
import { Box } from '~/commonComponents/Box';
import { Column } from '~/commonComponents/Column';
import { Text } from '~/commonComponents/Text';
import { EmptyFavorites } from '~/components/ProfessionalsHub/components/FavoritesList/EmptyFavorites';
import { EmptyFavoritesDescription } from '~/components/ProfessionalsHub/components/FavoritesList/EmptyFavoritesDescription';
import { IUser } from '~/models';
import { Colors } from '~/themes/colors';
import { ProfessionalList } from '../ProfessionalList';
import { IProfessionalTabPanelProps } from '../types';

export const FavoriteTabPanel = ({
  isInviting,
  isLoading,
  selectedProfessionals,
  onClosePopup,
  onSentInvitations,
  onSelectProfessionals,
  isSelectionMode,
  profession,
  data = [],
}: IProfessionalTabPanelProps<IUser>) => {
  const professionals = useMemo(() => {
    return data?.map(
      (it) =>
        ({
          ...it,
          profile_image: (it as any)?.profileImage,
          full_name: (it as any)?.fullname,
          isFavorite: true,
          professions: (it as any)?.professions,
        }) as IUser & { professions: string[] },
    );
  }, [data]);

  const isEmpty = !isLoading && professionals.length === 0;

  return (
    <Column flex={1}>
      {!isEmpty && !isLoading && (
        <Text
          textAlign="center"
          italic
          color={Colors.neutral_500}
          maxWidth={'80%'}
          alignSelf="center"
        >
          Send invites to as many professionals as you like! They’ll be auto-confirmed upon
          accepting the offer at the listed rate and time.
        </Text>
      )}

      <Box flex={1}>
        <ProfessionalList
          EmptyComponent={
            <EmptyFavorites
              title="No Favorite Professionals"
              description={
                <Box marginTop={16}>
                  <EmptyFavoritesDescription />
                </Box>
              }
              width="100%"
              style={{
                height: 'auto',
                marginTop: 0,
              }}
              emptyScreenStyle={{
                marginTop: 0,
                height: 'auto',
              }}
            />
          }
          isEmpty={isEmpty}
          isInviting={isInviting}
          isLoading={isLoading}
          professionals={professionals}
          selectedProfessionals={selectedProfessionals}
          selectedProfession={profession}
          onClose={onClosePopup}
          onSelectProfessionals={onSelectProfessionals}
          onSentInvitations={onSentInvitations}
          confirmButtonText={isSelectionMode ? 'Confirm' : undefined}
        />
      </Box>
    </Column>
  );
};
